import React, { Component } from 'react';
import { ThemeContext } from '../ThemeContext';
import { Player } from "@lottiefiles/react-lottie-player";
import notFound from "../assets/raw/lottie-lonely-404.json";
import { Link } from 'react-router-dom';

class NotFound extends Component {
    static contextType = ThemeContext;

    render() {
        const { message } = this.props;

        return (
            <div className="ps-not-found">
                <Player autoplay loop src={notFound} style={{ height: 'auto', width: '70%', maxWidth: 320 }} />
                {message && (
                    <div className="ps-alert ps-alert-danger" style={{ marginTop: '1.5rem', maxWidth: 360 }}>
                        {message}
                    </div>
                )}
                <Link to="/" style={{
                    display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
                    background: 'var(--accent)', color: 'white',
                    padding: '0.75rem 1.5rem',
                    borderRadius: 'var(--radius-xl)',
                    fontWeight: '600', fontSize: '13px',
                    textDecoration: 'none', marginTop: '1.5rem',
                    boxShadow: 'var(--shadow-accent)',
                    fontFamily: 'var(--font-sans)',
                }}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                        <polyline points="9 22 9 12 15 12 15 22"/>
                    </svg>
                    Take Me Home
                </Link>
            </div>
        );
    }
}

export default NotFound;
